import React from 'react'
import Swal from 'sweetalert2';
import { Link } from "react-router-dom";
import authAxios from "../../services/Token";
import tema from "../../services/Plantilla";
import { DefaultLayout } from '../../layout/theme-customizer';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSave, faTimes, faEye, faEdit, faTrashAlt, faSearch, faPlus, faImage, faEyeSlash, faPrint, faFileExcel, faDownload, faPaperPlane } from '@fortawesome/free-solid-svg-icons';
import * as XLSX from 'xlsx';
import Url, { apiImage } from "../../services/Api";

const defaultLayout = Object.keys(DefaultLayout);
const layout = defaultLayout;

class Editar extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            load: '',
            Titulo: '',
            datosCargados: false,
            DataPrincipal: [],
            DataSecundarias: [],
            ModeloPrincipal: [],
            ModeloSecundario: [],
            tablasHijas: [],
            errores: [],
            isLoadingOpen: false,
            TablaModal: [],
            TablaModalOriginal: [],
            Campo: '',
            IdCampo: '',
            tablaActual: '',
            campoId: '',
            campoNombre: '',
            campoOpcional: '',
            searchTerm: '',
            btnGuadar: 0,
            idmenu: null,
            ide: null,
            hijosCargados: {},
            cargandoHijos: {},
            hijosExpandidos: {},
            modelosHijos: {},

            // Nuevo estado para el estado_inventario
            estadoInventario: null,

            // Estados para el modal de formulario de detalle
            showFormModal: false,
            ModeloFormularioDetalle: [],
            idmenuDetalle: null,
            idRegistroDetalle: null,
            btnGuadarDetalle: 0,
            TablaRelacionActual: null,
            CampoRelacionActual: null,
            IdPadre: null,

            // Para diferenciar entre búsqueda principal y de detalle
            esBusquedaDetalle: false
        }
    }

    cambioValor = (e) => {
        const state = this.state.usuario;
        state[e.target.name] = e.target.value;
        this.setState({ usuario: state });
    };

    verificarError(elemento) {
        return this.state.errores.indexOf(elemento) !== -1;
    }

    // Método para verificar si los botones deben estar habilitados
    botonesHabilitados = () => {
        const { estadoInventario } = this.state;
        // Si estado_inventario es diferente de 1, los botones (excepto imprimir) deben estar deshabilitados
        return estadoInventario === 1;
    }

    // Método para validar que los precios de factura_detalle sean mayores a 0
    validarPreciosFacturaDetalle = () => {
        const ide = this.state.ide || localStorage.getItem('Archivo');
        let datos = this.state.hijosCargados[`factura_detalle-${ide}`]?.datos;

        if (!datos) {
            for (const k in this.state.hijosCargados) {
                if (k.toLowerCase().startsWith('factura_detalle')) {
                    datos = this.state.hijosCargados[k]?.datos;
                    break;
                }
            }
        }

        if (!datos || datos.length === 0) {
            Swal.fire({
                icon: 'warning',
                title: 'Sin detalles de factura',
                text: 'No se encontraron ítems en factura_detalle o aún no han terminado de cargar. Por favor espere o verifique los datos.',
                confirmButtonText: 'Entendido'
            });
            return false;
        }

        const itemsInvalidos = datos.filter(item => {
            if (item.precio === null || item.precio === undefined || item.precio === '') {
                return true;
            }
            const val = parseFloat(item.precio);
            return isNaN(val) || val <= 0;
        });

        if (itemsInvalidos.length > 0) {
            const listaItemsHtml = itemsInvalidos.map((item) => {
                const orden = item.orden_interna || item.orden || 'Sin Orden';
                const codigo = item.codigo || 'N/A';
                const desc = item.descripcion || 'Sin descripción';
                const precioActual = (item.precio !== null && item.precio !== undefined && item.precio !== '') ? item.precio : '0';

                return `<li style="margin-bottom: 8px; padding: 6px; border-bottom: 1px solid #dee2e6; text-align: left;">
                    <span class="badge bg-danger me-1">Orden Interna #${orden}</span>
                    <strong>${codigo}</strong>: ${desc}
                    <br />
                    <span class="text-danger fw-bold" style="font-size: 11px;">Precio actual: $${precioActual}</span>
                </li>`;
            }).join('');

            Swal.fire({
                icon: 'error',
                title: 'Precios en 0 o vacíos detectados',
                html: `
                    <div style="text-align: left;">
                        <p style="margin-bottom: 8px;">
                            Para cambiar el estado a <strong>Aprobado</strong> o enviar la factura a Siigo, todos los ítems de <code>factura_detalle</code> deben tener un precio mayor a 0.
                        </p>
                        <p class="text-danger fw-bold mb-2">
                            Se encontraron ${itemsInvalidos.length} ítem(s) con precio menor o igual a cero:
                        </p>
                        <div style="max-height: 250px; overflow-y: auto; background-color: #f8f9fa; border: 1px solid #dc3545; border-radius: 4px; padding: 8px;">
                            <ul style="list-style-type: none; padding-left: 0; margin-bottom: 0;">
                                ${listaItemsHtml}
                            </ul>
                        </div>
                        <p class="small text-muted mt-2 mb-0">
                            Por favor modifique los precios correspondientes a cada número de orden interna antes de guardar como Aprobada.
                        </p>
                    </div>
                `,
                confirmButtonText: 'Entendido',
                width: '620px'
            });
            return false;
        }

        return true;
    }

    handleImprimirClick = async () => {
        var idOrden = localStorage.getItem('Archivo');
        var TablaId = localStorage.getItem('TablaId');
        // Mostrar loading
        Swal.fire({
            title: 'Generando Documento',
            text: 'Por favor espere...',
            allowOutsideClick: false,
            didOpen: () => {
                Swal.showLoading();
            }
        });

        try {
            // Primero intentar con el endpoint que devuelve base64 (como en tu código original)
            const response = await authAxios.get(`/documento_pdf/${idOrden}/${TablaId}`);

            if (response.data.status) {
                // Crear ventana emergente con PDF usando iframe
                const pdfWindow = window.open('', '_blank');
                if (pdfWindow) {
                    pdfWindow.document.write(`
                    <html>
                        <head>
                            <title>Documento #${idOrden}</title>
                            <style>
                                body { margin: 0; padding: 0; overflow: hidden; }
                                iframe { width: 100%; height: 100vh; border: none; }
                            </style>
                        </head>
                        <body>
                            <iframe 
                                src="data:application/pdf;base64,${response.data.data}" 
                                title="Documento #${idOrden}"
                            ></iframe>
                        </body>
                    </html>
                `);
                }

                Swal.close();

                Swal.fire({
                    icon: 'success',
                    title: 'PDF generado',
                    text: 'El documento se abrirá en una nueva ventana',
                    timer: 2000,
                    showConfirmButton: false
                });

                return true;
            } else {
                // Si el endpoint base64 falla, intentar con el método de blob
                throw new Error('Error en respuesta base64');
            }

        } catch (error) {
            console.log('Intentando método alternativo de descarga...');

            try {
                // Fallback: intentar descarga directa con blob
                const directResponse = await authAxios.get(`/documento_pdf/${idOrden}/${TablaId}`, {
                    responseType: 'blob'
                });

                const url = window.URL.createObjectURL(new Blob([directResponse.data], { type: 'application/pdf' }));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', `documento_${idOrden}_${Date.now()}.pdf`);
                document.body.appendChild(link);
                link.click();
                link.remove();

                window.URL.revokeObjectURL(url);

                Swal.close();
                Swal.fire({
                    icon: 'success',
                    title: 'Descarga iniciada',
                    text: 'El documento se está descargando',
                    timer: 2000,
                    showConfirmButton: false
                });

                return true;

            } catch (fallbackError) {
                console.error('Error en ambos métodos:', fallbackError);
                Swal.close();
                Swal.fire({
                    icon: 'error',
                    title: 'Error',
                    text: 'No se pudo generar el documento',
                    confirmButtonText: 'Entendido'
                });
                return false;
            }
        }
    }

    handleImprimirAgrupadoClick = async () => {
        var idOrden = localStorage.getItem('Archivo');
        var TablaId = localStorage.getItem('TablaId');
        // Mostrar loading
        Swal.fire({
            title: 'Generando Documento Agrupado',
            text: 'Por favor espere...',
            allowOutsideClick: false,
            didOpen: () => {
                Swal.showLoading();
            }
        });

        try {
            // Usar el endpoint agrupado
            const response = await authAxios.get(`/documento_pdf_agrupado/${idOrden}/${TablaId}`);

            if (response.data.status) {
                // Crear ventana emergente con PDF usando iframe
                const pdfWindow = window.open('', '_blank');
                if (pdfWindow) {
                    pdfWindow.document.write(`
                    <html>
                        <head>
                            <title>Documento Agrupado #${idOrden}</title>
                            <style>
                                body { margin: 0; padding: 0; overflow: hidden; }
                                iframe { width: 100%; height: 100vh; border: none; }
                            </style>
                        </head>
                        <body>
                            <iframe 
                                src="data:application/pdf;base64,${response.data.data}" 
                                title="Documento Agrupado #${idOrden}"
                            ></iframe>
                        </body>
                    </html>
                `);
                }

                Swal.close();

                Swal.fire({
                    icon: 'success',
                    title: 'PDF Agrupado generado',
                    text: 'El documento agrupado se abrirá en una nueva ventana',
                    timer: 2000,
                    showConfirmButton: false
                });

                return true;
            } else {
                throw new Error('Error en respuesta base64');
            }

        } catch (error) {
            console.log('Intentando método alternativo de descarga para documento agrupado...');

            try {
                // Fallback: intentar descarga directa con blob
                const directResponse = await authAxios.get(`/documento_pdf_agrupado/${idOrden}/${TablaId}`, {
                    responseType: 'blob'
                });

                const url = window.URL.createObjectURL(new Blob([directResponse.data], { type: 'application/pdf' }));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', `documento_agrupado_${idOrden}_${Date.now()}.pdf`);
                document.body.appendChild(link);
                link.click();
                link.remove();

                window.URL.revokeObjectURL(url);

                Swal.close();
                Swal.fire({
                    icon: 'success',
                    title: 'Descarga iniciada',
                    text: 'El documento agrupado se está descargando',
                    timer: 2000,
                    showConfirmButton: false
                });

                return true;

            } catch (fallbackError) {
                console.error('Error en ambos métodos:', fallbackError);
                Swal.close();
                Swal.fire({
                    icon: 'error',
                    title: 'Error',
                    text: 'No se pudo generar el documento agrupado',
                    confirmButtonText: 'Entendido'
                });
                return false;
            }
        }
    }

    handleDescargarRipsJson = async () => {
        const idFactura = this.state.ide || localStorage.getItem('Archivo');
        if (!idFactura) {
            Swal.fire('Error', 'No se encontró el ID de la factura', 'error');
            return;
        }

        Swal.fire({
            title: 'Generando RIPS JSON',
            text: 'Por favor espere...',
            allowOutsideClick: false,
            didOpen: () => {
                Swal.showLoading();
            }
        });

        try {
            const response = await authAxios.get(`/factura_electronica/rips_json/${idFactura}`);
            Swal.close();

            if (response.data) {
                const dataStr = "data:text/json;charset=utf-8," + encodeURIComponent(JSON.stringify(response.data, null, 2));
                const downloadAnchor = document.createElement('a');
                downloadAnchor.setAttribute("href", dataStr);
                const numFactura = response.data.numFactura || `IDB${idFactura}`;
                downloadAnchor.setAttribute("download", `RIPS_${numFactura}_${new Date().toISOString().split('T')[0]}.json`);
                document.body.appendChild(downloadAnchor);
                downloadAnchor.click();
                downloadAnchor.remove();

                Swal.fire({
                    icon: 'success',
                    title: 'RIPS Generado',
                    text: 'El archivo JSON se ha descargado correctamente.',
                    timer: 2000,
                    showConfirmButton: false
                });
            } else {
                Swal.fire('Error', 'No se recibieron datos para generar el RIPS', 'error');
            }
        } catch (error) {
            Swal.close();
            console.error('Error al descargar RIPS JSON:', error);
            const msg = error.response?.data?.message || 'Error al generar el archivo RIPS JSON';
            Swal.fire('Error', msg, 'error');
        }
    };

    handleEnviarSiigo = async () => {
        const idFactura = this.state.ide || localStorage.getItem('Archivo');
        if (!idFactura) {
            Swal.fire('Error', 'No se encontró el ID de la factura', 'error');
            return;
        }

        // 1. Validar que la factura esté en estado Aprobado (2)
        if (parseInt(this.state.estadoInventario) !== 2) {
            Swal.fire({
                icon: 'warning',
                title: 'Factura no aprobada',
                text: 'La factura debe estar en estado Aprobado para poder enviarse a Siigo.',
                confirmButtonText: 'Entendido'
            });
            return;
        }

        // 2. Validar que todos los precios de factura_detalle sean mayores a 0
        if (!this.validarPreciosFacturaDetalle()) {
            return;
        }

        const confirmacion = await Swal.fire({
            title: '¿Enviar a Siigo?',
            text: `¿Está seguro de enviar la factura #${idFactura} a Siigo?`,
            icon: 'question',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Sí, enviar factura',
            cancelButtonText: 'Cancelar'
        });

        if (!confirmacion.isConfirmed) {
            return;
        }

        Swal.fire({
            title: 'Enviando a Siigo',
            text: 'Conectando con la API de Siigo...',
            allowOutsideClick: false,
            didOpen: () => {
                Swal.showLoading();
            }
        });

        try {
            const response = await authAxios.post(`/factura_electronica/enviar_siigo/${idFactura}`);
            Swal.close();

            if (response.data.status) {
                Swal.fire({
                    icon: 'success',
                    title: '¡Factura Enviada!',
                    text: response.data.mensaje || 'La factura se envió exitosamente a Siigo.',
                    confirmButtonText: 'Aceptar'
                });
                this.setState(prevState => ({
                    DataPrincipal: {
                        ...prevState.DataPrincipal,
                        siigo: response.data.id_siigo || 'enviado',
                        id_siigo: response.data.id_siigo || 'enviado'
                    }
                }));
                this.refrescarTodosLosDatos();
            } else {
                Swal.fire({
                    icon: 'error',
                    title: 'Error de Siigo',
                    text: response.data.mensaje || 'No se pudo enviar la factura a Siigo.',
                    confirmButtonText: 'Entendido'
                });
            }
        } catch (error) {
            Swal.close();
            console.error('Error al enviar factura a Siigo:', error);
            const msg = error.response?.data?.mensaje || error.response?.data?.message || 'Error de conexión al enviar la factura a Siigo';
            Swal.fire({
                icon: 'error',
                title: 'Error',
                text: msg,
                confirmButtonText: 'Entendido'
            });
        }
    };

    exportarTablaHijaExcel = (tablaNombre, datos, camposVisibles) => {
        if (!datos || datos.length === 0) {
            Swal.fire('Atención', 'No hay datos para exportar', 'warning');
            return;
        }

        const dataToExport = datos.map((reg, idx) => {
            const row = { '#': idx + 1 };
            camposVisibles.forEach(col => {
                let val = reg[col.nombre_campo + '_name'] !== undefined && reg[col.nombre_campo + '_name'] !== null
                    ? reg[col.nombre_campo + '_name']
                    : reg[col.nombre_campo];
                row[col.nombre_titulo || col.nombre_campo] = val !== null && val !== undefined ? val : '';
            });
            return row;
        });

        const worksheet = XLSX.utils.json_to_sheet(dataToExport);
        const workbook = XLSX.utils.book_new();
        const sheetName = (tablaNombre || 'Detalle').substring(0, 31);
        XLSX.utils.book_append_sheet(workbook, worksheet, sheetName);
        const nombreArchivo = `${tablaNombre || 'detalle'}_${this.state.ide || ''}_${new Date().toISOString().split('T')[0]}.xlsx`;
        XLSX.writeFile(workbook, nombreArchivo);
    };

    CargarRelaciones = (menu) => {
        var iditem = localStorage.getItem('Archivo');
        authAxios.get("modulos/listarelaciones/" + menu)
            .then((datosRespuesta) => {
                console.log("Tablas hijas disponibles:", datosRespuesta.data.tabla);
                const tablaHijas = datosRespuesta.data.tabla || [];
                this.setState({ tablasHijas: tablaHijas });

                tablaHijas.forEach((tablaHija, index) => {
                    console.log(iditem, tablaHija.tablaforanea, tablaHija.relacion_fk, index);
                    this.VerHijosDetalle(iditem, tablaHija.tablaforanea, tablaHija.relacion_fk, index);
                });
            })
            .catch(error => {
                console.error("Error al cargar tablas hijas:", error);
            });
    }

    VerHijosDetalle = (ordenId, tabla, campo, index) => {
        const key = `${tabla}-${ordenId}`;

        authAxios.get(`master/verrelacion/${tabla}/${campo}/${ordenId}`)
            .then((datosRespuesta) => {
                console.log(`Datos Secundarios ${tabla}:`, datosRespuesta.data);

                const datos = datosRespuesta.data.data?.data || datosRespuesta.data.data || [];
                const modelo = datosRespuesta.data.modelo || [];

                this.setState(prevState => ({
                    hijosCargados: {
                        ...prevState.hijosCargados,
                        [key]: {
                            datos: Array.isArray(datos) ? datos : [],
                            modelo: modelo
                        }
                    },
                    modelosHijos: {
                        ...prevState.modelosHijos,
                        [tabla]: modelo
                    },
                    hijosExpandidos: {
                        ...prevState.hijosExpandidos,
                        [key]: true
                    }
                }));
            })
            .catch(error => {
                console.error(`Error al cargar detalles de ${tabla}:`, error);
            });
    }

    componentDidMount() {
        Swal.showLoading();

        var ide = localStorage.getItem('Archivo');
        var menu = localStorage.getItem('TablaId');

        this.setState({ idmenu: menu, ide: ide, IdPadre: ide });

        authAxios.get("master/ver/" + menu + "/" + ide)
            .then((datosRespuesta) => {
                let modelo = datosRespuesta.data.modelo;
                let resultado = datosRespuesta.data.result || {};
                let dataRaw = datosRespuesta.data.data || {};
                let dataMerged = { ...dataRaw, ...resultado };

                console.log('tabla principal:', datosRespuesta.data);
                console.log('modelo principal:', modelo[0].nombre_tabla);
                console.log('estado_inventario:', resultado.estado_inventario); // Verificar el valor

                Swal.close();
                this.setState({
                    datosCargados: true,
                    DataPrincipal: dataMerged,
                    load: '',
                    ModeloPrincipal: modelo,
                    Titulo: modelo[0].nombre_tabla,
                    estadoInventario: resultado.estado_inventario // Guardar el estado_inventario
                });

                // Asignar valores a los campos del formulario
                setTimeout(() => {
                    this.asignarValoresFormulario(modelo, resultado);
                }, 300);

                this.CargarRelaciones(modelo[0].nombre_tabla);
            })
            .catch(error => {
                Swal.close();
                console.error("Error al cargar datos:", error);
                Swal.fire('Error', 'No se pudieron cargar los datos', 'error');
            });
    }

    asignarValoresFormulario = (modelo, data) => {
        modelo.forEach((item) => {
            if (item.trae_tabla != null) {
                const nameElement = document.getElementById("edit_" + item.nombre_campo + "_name");
                if (nameElement) {
                    nameElement.value = data[item.nombre_campo + "_name"] || '';
                }
            }
        });

        modelo.forEach((item) => {
            if (item.tipo_dato === "blob") {
                const imgElement = document.getElementById("edit_img_" + item.nombre_campo);
                if (imgElement) {
                    imgElement.src = data[item.nombre_campo] != null
                        ? apiImage + data[item.nombre_campo]
                        : "https://static.vecteezy.com/system/resources/previews/022/059/000/non_2x/no-image-available-icon-vector.jpg";
                }
            } else {
                const inputElement = document.getElementById("edit_" + item.nombre_campo);
                if (inputElement) {
                    inputElement.value = data[item.nombre_campo] || '';
                }
            }
        });
    }

    // Búsqueda para el formulario principal
    Buscar = (tabla, id, nombre, campo, opcional) => {
        // Verificar si los botones están habilitados antes de permitir la búsqueda
        if (!this.botonesHabilitados()) {
            Swal.fire({
                icon: 'warning',
                title: 'Acción no permitida',
                text: 'No se pueden realizar cambios porque el inventario está inactivo',
                confirmButtonText: 'Entendido'
            });
            return;
        }

        this.setState({
            isLoadingOpen: true,
            TablaModal: [],
            TablaModalOriginal: [],
            Campo: campo,
            IdCampo: campo,
            tablaActual: tabla,
            campoId: id,
            campoNombre: nombre,
            campoOpcional: opcional,
            searchTerm: '',
            esBusquedaDetalle: false
        });

        var da = { tabla, id, nombre, opcional };

        authAxios.post("master/relacion", da)
            .then((datosRespuesta) => {
                console.log("Datos del modal:", datosRespuesta.data);
                this.setState({
                    isLoadingOpen: false,
                    TablaModal: datosRespuesta.data,
                    TablaModalOriginal: datosRespuesta.data
                });
            })
            .catch(error => {
                console.error("Error al buscar:", error);
                this.setState({ isLoadingOpen: false });
                Swal.fire('Error', 'No se pudieron cargar los datos', 'error');
            });
    }

    PasarValor = async (funcion, campo, resultado_campo, campo_extra) => {
        var valor = document.getElementById("detalle_" + campo + "").value;
        var id_registro = document.getElementById("detalle_" + campo_extra + "").value;

        var da = { funcion, campo, valor, id_registro };

        try {
            const response = await authAxios.post("funciones/pasarvalor", da);
            console.log("Datos recibidos:", response.data);
            return response.data;
        } catch (error) {
            console.error("Error al buscar:", error);
            throw error;
        }
    }
    BuscarValor = async (funcion, campo, resultado_campo, campo_extra) => {
        var valor = document.getElementById("detalle_" + campo + "").value;
        var id_registro = document.getElementById("detalle_" + campo_extra + "").value;

        var da = { funcion, campo, valor, id_registro };

        try {
            const response = await authAxios.post("funciones/buscarvalor", da);
            console.log("Datos recibidos:", response.data);
            let c = response.data.campo;
            let r = response.data.resultado;
            document.getElementById("detalle_" + c + "").value = r;

        } catch (error) {
            console.error("Error al buscar:", error);
            throw error;
        }
    }

    FuncionGenerica = async (campo, funcion) => {
        try {
            const response = await authAxios.get("funciones/buscar_funcion/" + funcion + "/" + campo);
            console.log("Datos de la funcion y de los campos:", response.data);

            let campos_f = response.data.funcion;
            let proceso = response.data.lista.operacion;

            // Declarar variables
            let c1 = 0, c2 = 0, c3 = 0;
            let res = null;

            if (campos_f.campo1 != null) {
                c1 = document.getElementById("detalle_" + campos_f.campo1 + "")?.value || 0;
            }
            if (campos_f.campo2 != null) {
                c2 = document.getElementById("detalle_" + campos_f.campo2 + "")?.value || 0;
            }
            if (campos_f.campo3 != null) {
                c3 = document.getElementById("detalle_" + campos_f.campo3 + "")?.value || 0;
            }

            if (campos_f.campo_resultado != null) {
                if (campos_f.tabla_secundaria != null) {
                    res = document.getElementById("edit_" + campos_f.campo_resultado + "");
                } else {
                    res = document.getElementById("detalle_" + campos_f.campo_resultado + "");
                }
            }

            let resultado;

            switch (proceso) {
                case "calcula_iva":
                    var subtotal = (parseInt(c2) * (parseInt(c1) / 100));
                    resultado = (parseFloat(c2) + subtotal) * c3;
                    break;
                case "suma":
                    resultado = parseFloat(c1) + parseFloat(c2);
                    break;
                case "resta":
                    resultado = parseFloat(c1) - parseFloat(c2);
                    break;
                case "multiplica":
                    resultado = parseFloat(c1) * parseFloat(c2);
                    break;
                case "division":
                    resultado = parseFloat(c1) / parseFloat(c2);
                    break;
                case "pasar_valor":
                    resultado = await this.PasarValor(funcion, campo, campos_f.campo_resultado, campos_f.campo2);
                    break;
                case "busca_valor":
                    resultado = await this.BuscarValor(funcion, campo, campos_f.campo_resultado, campos_f.campo2);
                    break;
                default:
                    resultado = '';
                    break;
            }

            if (res) {
                res.value = resultado;
            }

        } catch (error) {
            console.error("Error al buscar:", error);
            Swal.fire('Error', 'No se pudieron cargar los datos', 'error');
        }
    }

    // Búsqueda para el modal de detalle
    BuscarDetalle = (tabla, id, nombre, campo, opcional) => {
        // Verificar si los botones están habilitados antes de permitir la búsqueda
        if (!this.botonesHabilitados()) {
            Swal.fire({
                icon: 'warning',
                title: 'Acción no permitida',
                text: 'No se pueden realizar cambios porque el inventario está inactivo',
                confirmButtonText: 'Entendido'
            });
            return;
        }

        // Guardar el nombre del campo sin prefijo para usarlo en SeleccionarDetalle
        const campoOriginal = campo;

        this.setState({
            isLoadingOpen: true,
            TablaModal: [],
            TablaModalOriginal: [],
            Campo: "detalle_" + campoOriginal,
            IdCampo: "detalle_" + campoOriginal,
            tablaActual: tabla,
            campoId: id,
            campoNombre: nombre,
            campoOpcional: opcional,
            searchTerm: '',
            esBusquedaDetalle: true
        });

        var da = { tabla, id, nombre, opcional };

        authAxios.post("master/relacion", da)
            .then((datosRespuesta) => {
                console.log("Datos del modal para detalle:", datosRespuesta.data);
                this.setState({
                    isLoadingOpen: false,
                    TablaModal: datosRespuesta.data,
                    TablaModalOriginal: datosRespuesta.data
                });
            })
            .catch(error => {
                console.error("Error al buscar:", error);
                this.setState({ isLoadingOpen: false });
                Swal.fire('Error', 'No se pudieron cargar los datos', 'error');
            });
    }

    handleSearch = (e) => {
        const searchValue = e.target.value.toLowerCase();
        const { TablaModalOriginal, campoNombre, campoOpcional } = this.state;

        this.setState({ searchTerm: searchValue });

        if (!TablaModalOriginal || TablaModalOriginal.length === 0) {
            return;
        }

        if (searchValue.trim() === '') {
            this.setState({ TablaModal: TablaModalOriginal });
        } else {
            const filtered = TablaModalOriginal.filter(item => {
                const nombreValue = item[campoNombre] ? item[campoNombre].toString().toLowerCase() : '';
                let opcionalValue = '';
                if (campoOpcional && item[campoOpcional]) {
                    opcionalValue = item[campoOpcional].toString().toLowerCase();
                }
                const idValue = item.id ? item.id.toString().toLowerCase() : '';

                return nombreValue.includes(searchValue) ||
                    opcionalValue.includes(searchValue) ||
                    idValue.includes(searchValue);
            });

            this.setState({ TablaModal: filtered });
        }
    }

    // Seleccionar para formulario principal
    Seleccionar = (id, nombre, tabla) => {
        console.log("Seleccionando para principal:", id, nombre, tabla);
        const { Campo, IdCampo, tablaActual } = this.state;

        // Validar si se está intentando cambiar el estado_inventario a 2 (Aprobado)
        if ((Campo === 'estado_inventario' || tablaActual === 'estado_inventario') && parseInt(id) === 2) {
            if (!this.validarPreciosFacturaDetalle()) {
                return;
            }
        }

        // Verificar si los elementos existen antes de asignar
        const campoNameElement = document.getElementById("edit_" + Campo + "_name");
        const campoIdElement = document.getElementById("edit_" + Campo);

        if (campoNameElement) {
            campoNameElement.value = nombre;
        } else {
            console.warn("Campo no encontrado: edit_" + Campo + "_name");
        }

        if (campoIdElement) {
            campoIdElement.value = id;
        } else {
            console.warn("Campo no encontrado: edit_" + Campo);
        }

        // Cerrar modal
        const modal = document.getElementById('ModalSelectEdit');
        if (modal) {
            const bootstrapModal = window.bootstrap.Modal.getInstance(modal);
            if (bootstrapModal) {
                bootstrapModal.hide();
            }
        }
    }

    // Seleccionar para modal de detalle
    SeleccionarDetalle = (id, nombre, tabla) => {
        console.log("Seleccionando para detalle:", id, nombre, tabla);
        const { Campo, IdCampo, campoId } = this.state;

        // El campo oculto es "detalle_" + nombre_del_campo (ej: detalle_id_producto)
        const campoNameElement = document.getElementById(Campo + "_name");
        const campoIdElement = document.getElementById(IdCampo);

        console.log("Asignando a campos:", Campo + "_name", IdCampo);
        console.log("campoId (trae_value):", campoId);

        if (campoNameElement) {
            campoNameElement.value = nombre;
        } else {
            console.warn("Campo no encontrado:", Campo + "_name");
        }

        if (campoIdElement) {
            campoIdElement.value = id;
        } else {
            console.warn("Campo no encontrado:", IdCampo);
        }

        // Cerrar modal
        const modal = document.getElementById('ModalSelectEdit');
        if (modal) {
            const bootstrapModal = window.bootstrap.Modal.getInstance(modal);
            if (bootstrapModal) {
                bootstrapModal.hide();
            }
        }
    }

    // Función para abrir el modal de formulario para nuevo registro en tabla hija
    abrirFormularioNuevo = (tabla, campo, idPadre, idMenu) => {
        // Verificar si los botones están habilitados
        if (!this.botonesHabilitados()) {
            Swal.fire({
                icon: 'warning',
                title: 'Acción no permitida',
                text: 'No se pueden agregar registros porque el inventario está inactivo',
                confirmButtonText: 'Entendido'
            });
            return;
        }

        this.setState({
            showFormModal: true,
            ModeloFormularioDetalle: [],
            idmenuDetalle: idMenu,
            idRegistroDetalle: null,
            TablaRelacionActual: tabla,
            CampoRelacionActual: campo,
            IdPadre: idPadre,
            isLoadingOpen: true
        });

        Swal.showLoading();

        // Obtener la configuración del formulario desde el backend
        const u = localStorage.getItem("idusuario");

        authAxios.get(`master/vermodelo/${idMenu}/${u}`)
            .then((datosRespuesta) => {
                console.log("Datos del formulario para nuevo registro:", datosRespuesta.data);

                this.setState({
                    ModeloFormularioDetalle: datosRespuesta.data.modelo || [],
                    isLoadingOpen: false
                });

                Swal.close();

                setTimeout(() => {
                    this.limpiarFormularioDetalle();

                    // Si hay un campo que debe llevar el ID del padre, asignarlo
                    if (campo) {
                        const campoHidden = document.getElementById("detalle_" + campo);
                        console.log("Asignando ID padre a campo:", "detalle_" + campo, "valor:", idPadre);
                        if (campoHidden) {
                            campoHidden.value = idPadre;
                        } else {
                            console.warn("Campo padre no encontrado:", "detalle_" + campo);
                        }
                    }
                }, 300);
            })
            .catch(error => {
                console.error("Error al cargar modelo de tabla hija:", error);
                Swal.close();
                this.setState({ isLoadingOpen: false });
                Swal.fire('Error', 'No se pudo cargar el formulario', 'error');
            });
    }

    // Función para abrir el modal de formulario para editar registro en tabla hija
    abrirFormularioEditar = (idMenu, idRegistro, tabla, campo, idPadre) => {
        // Verificar si los botones están habilitados
        if (!this.botonesHabilitados()) {
            Swal.fire({
                icon: 'warning',
                title: 'Acción no permitida',
                text: 'No se pueden editar registros porque el inventario está inactivo',
                confirmButtonText: 'Entendido'
            });
            return;
        }

        this.setState({
            showFormModal: true,
            idmenuDetalle: idMenu,
            idRegistroDetalle: idRegistro,
            TablaRelacionActual: tabla,
            CampoRelacionActual: campo,
            IdPadre: idPadre,
            ModeloFormularioDetalle: []
        });

        Swal.showLoading();

        authAxios.get(`master/ver/${idMenu}/${idRegistro}`)
            .then((datosRespuesta) => {
                const lista = datosRespuesta.data.result;
                const campos = datosRespuesta.data.modelo;

                console.log("Datos para editar:", lista);
                console.log("Modelo para editar:", campos);

                this.setState({ ModeloFormularioDetalle: campos });

                setTimeout(() => {
                    // Asignar valores a los campos
                    campos.forEach((item) => {
                        if (item.trae_tabla != null) {
                            const nameElement = document.getElementById("detalle_" + item.nombre_campo + "_name");
                            if (nameElement) {
                                nameElement.value = lista[item.nombre_campo + "_name"] || '';
                            }
                        }
                    });

                    campos.forEach((item) => {
                        if (item.tipo_dato === "blob") {
                            const imgElement = document.getElementById("detalle_img_" + item.nombre_campo);
                            if (imgElement) {
                                imgElement.src = lista[item.nombre_campo] != null
                                    ? apiImage + lista[item.nombre_campo]
                                    : "https://static.vecteezy.com/system/resources/previews/022/059/000/non_2x/no-image-available-icon-vector.jpg";
                            }
                        } else {
                            const inputElement = document.getElementById("detalle_" + item.nombre_campo);
                            if (inputElement) {
                                inputElement.value = lista[item.nombre_campo] || '';
                            }
                        }
                    });

                    // Asignar el ID del padre al campo correspondiente
                    if (campo && idPadre) {
                        const campoHidden = document.getElementById("detalle_" + campo);
                        if (campoHidden) {
                            campoHidden.value = idPadre;
                        }
                    }

                    Swal.close();
                }, 300);
            })
            .catch(error => {
                console.error("Error al cargar datos para editar:", error);
                Swal.close();
                Swal.fire('Error', 'No se pudieron cargar los datos', 'error');
            });
    }

    // Función para guardar el formulario de detalle
    saveDetalle = () => {
        // Verificar si los botones están habilitados
        if (!this.botonesHabilitados()) {
            Swal.fire({
                icon: 'warning',
                title: 'Acción no permitida',
                text: 'No se pueden guardar cambios porque el inventario está inactivo',
                confirmButtonText: 'Entendido'
            });
            this.setState({ btnGuadarDetalle: 0 });
            return;
        }

        Swal.showLoading();
        this.setState({ btnGuadarDetalle: 1 });

        const form = document.getElementById("form_registro_detalle");
        const formData = new FormData(form);
        const u = localStorage.getItem("idusuario");
        const { idmenuDetalle, idRegistroDetalle, TablaRelacionActual, IdPadre, CampoRelacionActual } = this.state;

        // Si es un nuevo registro, aseguramos que tenga el ID del padre
        if (!idRegistroDetalle && CampoRelacionActual && IdPadre) {
            formData.append(CampoRelacionActual, IdPadre);
        }

        authAxios.post(`master/registrar/${idmenuDetalle}/${u}`, formData)
            .then((datosRespuesta) => {
                if (datosRespuesta.data.Status) {
                    Swal.fire({
                        icon: 'success',
                        title: idRegistroDetalle ? '¡Actualización exitosa!' : '¡Registro exitoso!',
                        text: datosRespuesta.data.msj,
                        timer: 2000,
                        showConfirmButton: true
                    });

                    this.setState({
                        btnGuadarDetalle: 0,
                        showFormModal: false
                    });

                    // Recargar TODOS los datos del módulo (datos principales y tablas hijas)
                    this.refrescarTodosLosDatos();

                    // Cerrar el modal
                    const modal = document.getElementById('FormularioModalDetalle');
                    if (modal) {
                        const bootstrapModal = window.bootstrap.Modal.getInstance(modal);
                        if (bootstrapModal) {
                            bootstrapModal.hide();
                        }
                    }
                } else {
                    Swal.close();
                    Swal.fire({
                        icon: 'error',
                        title: 'Error',
                        text: datosRespuesta.data.msj
                    });
                    this.setState({ btnGuadarDetalle: 0 });
                }
            })
            .catch(error => {
                console.error("Error al guardar:", error);
                Swal.close();
                Swal.fire({
                    icon: 'error',
                    title: 'Error',
                    text: 'No se pudo guardar el registro'
                });
                this.setState({ btnGuadarDetalle: 0 });
            });
    }

    // Método para refrescar todos los datos del módulo (datos principales y tablas hijas)
    refrescarTodosLosDatos = () => {
        const { idmenu, ide } = this.state;

        // Recargar datos principales
        authAxios.get("master/ver/" + idmenu + "/" + ide)
            .then((datosRespuesta) => {
                let modelo = datosRespuesta.data.modelo;
                let resultado = datosRespuesta.data.result || {};
                let dataRaw = datosRespuesta.data.data || {};
                let dataMerged = { ...dataRaw, ...resultado };

                console.log('Datos principales actualizados:', datosRespuesta.data);

                this.setState({
                    DataPrincipal: dataMerged,
                    ModeloPrincipal: modelo,
                    estadoInventario: resultado.estado_inventario
                });

                // Asignar valores a los campos del formulario principal
                setTimeout(() => {
                    this.asignarValoresFormulario(modelo, resultado);
                }, 300);
            })
            .catch(error => {
                console.error("Error al recargar datos principales:", error);
            });

        // Recargar todas las tablas hijas
        const { tablasHijas } = this.state;
        if (tablasHijas && tablasHijas.length > 0) {
            // Limpiar todos los hijos cargados
            this.setState({ hijosCargados: {} });

            // Recargar cada tabla hija
            tablasHijas.forEach((tablaHija, index) => {
                const key = `${tablaHija.tablaforanea}-${ide}`;
                this.setState(prevState => ({
                    hijosCargados: {
                        ...prevState.hijosCargados,
                        [key]: undefined
                    }
                }));
                this.VerHijosDetalle(ide, tablaHija.tablaforanea, tablaHija.relacion_fk, index);
            });
        }
    }

    limpiarFormularioDetalle = () => {
        const formularioDetalle = document.getElementById('form_registro_detalle');
        if (formularioDetalle) {
            formularioDetalle.reset();
        }

        const subId = document.getElementById('detalle_sub_id');
        if (subId) {
            subId.value = '';
        }

        // Limpiar todos los campos con prefijo "detalle_"
        const inputs = document.querySelectorAll('[id^="detalle_"]');
        inputs.forEach(input => {
            if (input.type !== 'hidden' && input.id !== 'detalle_sub_id' && !input.id.includes('_name')) {
                input.value = '';
            }
        });

        const inputsName = document.querySelectorAll('[id$="_name"]');
        inputsName.forEach(input => {
            if (input.id.startsWith('detalle_')) {
                input.value = '';
            }
        });

        const imagenes = document.querySelectorAll('[id^="detalle_img_"]');
        imagenes.forEach(img => {
            img.src = "https://static.vecteezy.com/system/resources/previews/022/059/000/non_2x/no-image-available-icon-vector.jpg";
        });
    }

    cerrarModalDetalle = () => {
        this.setState({ showFormModal: false });
        const modal = document.getElementById('FormularioModalDetalle');
        if (modal) {
            const bootstrapModal = window.bootstrap.Modal.getInstance(modal);
            if (bootstrapModal) {
                bootstrapModal.hide();
            }
        }
    }

    save = () => {
        // Verificar si los botones están habilitados
        if (!this.botonesHabilitados()) {
            Swal.fire({
                icon: 'warning',
                title: 'Acción no permitida',
                text: 'No se pueden guardar cambios porque el inventario está inactivo',
                confirmButtonText: 'Entendido'
            });
            return;
        }

        const form = document.getElementById("form_editar");
        const formData = new FormData(form);
        const estadoSeleccionado = formData.get('estado_inventario') || document.getElementById('edit_estado_inventario')?.value;

        // Si se va a guardar con estado Aprobado (2), validar que todos los precios sean mayores a 0
        if (parseInt(estadoSeleccionado) === 2) {
            if (!this.validarPreciosFacturaDetalle()) {
                return;
            }
        }

        Swal.showLoading();
        this.setState({ btnGuadar: 1 });

        const u = localStorage.getItem("idusuario");
        const { idmenu, ide } = this.state;

        authAxios.post(`master/registrar/${idmenu}/${u}`, formData)
            .then((datosRespuesta) => {
                if (datosRespuesta.data.Status) {
                    Swal.fire({
                        icon: 'success',
                        title: '¡Actualización exitosa!',
                        text: datosRespuesta.data.msj,
                        timer: 2000,
                        showConfirmButton: true
                    });

                    this.setState({ btnGuadar: 0 });

                    // Redirigir al listado
                    window.location.href = `${process.env.PUBLIC_URL}/pages/${idmenu}/Dubai`;
                } else {
                    Swal.close();
                    Swal.fire({
                        icon: 'error',
                        title: 'Error',
                        text: datosRespuesta.data.msj
                    });
                    this.setState({ btnGuadar: 0 });
                }
            })
            .catch(error => {
                console.error("Error al guardar:", error);
                Swal.close();
                Swal.fire({
                    icon: 'error',
                    title: 'Error',
                    text: 'No se pudo guardar el registro'
                });
                this.setState({ btnGuadar: 0 });
            });
    }

    borrarRegistroHijo = (idm, id, tabla, campo, ordenId) => {
        // Verificar si los botones están habilitados
        if (!this.botonesHabilitados()) {
            Swal.fire({
                icon: 'warning',
                title: 'Acción no permitida',
                text: 'No se pueden eliminar registros porque el inventario está inactivo',
                confirmButtonText: 'Entendido'
            });
            return;
        }

        const u = localStorage.getItem("idusuario");

        Swal.fire({
            title: "¿Está seguro de eliminar este registro?",
            text: "Esta acción no se puede deshacer",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#d33',
            cancelButtonColor: '#3085d6',
            confirmButtonText: "Sí, eliminar",
            cancelButtonText: "Cancelar",
            showLoaderOnConfirm: true,
            preConfirm: () => {
                return authAxios.get(`master/borrar/${idm}/${id}/${u}`)
                    .then(response => {
                        if (response.data.Status === false) {
                            throw new Error(response.data.msj || 'Error al eliminar el registro');
                        }
                        return response.data;
                    })
                    .catch(error => {
                        Swal.showValidationMessage(
                            error.response?.data?.msj || error.message || 'Error en la petición'
                        );
                    });
            },
            allowOutsideClick: () => !Swal.isLoading()
        }).then((result) => {
            if (result.isConfirmed) {
                Swal.fire({
                    icon: 'success',
                    title: '¡Eliminado!',
                    text: result.value?.msj || 'El registro ha sido eliminado correctamente',
                    showConfirmButton: true,
                    timer: 3000,
                    timerProgressBar: true
                }).then(() => {
                    // Recargar los datos de la tabla hija
                    const key = `${tabla}-${ordenId}`;
                    this.setState(prevState => ({
                        hijosCargados: {
                            ...prevState.hijosCargados,
                            [key]: undefined
                        }
                    }));
                    this.VerHijosDetalle(ordenId, tabla, campo, 0);
                });
            }
        }).catch(error => {
            console.error("Error al eliminar:", error);
            Swal.fire({
                icon: 'error',
                title: 'Error',
                text: 'No se pudo eliminar el registro',
                confirmButtonText: 'Aceptar'
            });
        });
    }

    renderCampoValor = (registro, campo) => {
        const valor = registro[campo.nombre_campo];

        if (valor === null || valor === undefined) return '-';

        switch (campo.tipo_dato) {
            case 'blob':
                return valor ? (
                    <a href={apiImage + valor} target="_blank" rel="noopener noreferrer">
                        Ver archivo
                    </a>
                ) : '-';
            default:
                if (typeof valor === 'string' && valor.length > 50) {
                    return valor.substring(0, 50) + '...';
                }
                return valor;
        }
    }

    renderTablasHijas = () => {
        const { tablasHijas, ide, hijosCargados, hijosExpandidos, cargandoHijos, modelosHijos, estadoInventario } = this.state;
        const botonesHabilitados = this.botonesHabilitados();

        if (!tablasHijas || tablasHijas.length === 0) {
            return (
                <div className="alert alert-info">
                    No hay tablas relacionadas
                </div>
            );
        }

        return tablasHijas.map((tablaHija, index) => {
            const key = `${tablaHija.tablaforanea}-${ide}`;
            const datosCargados = hijosCargados[key];
            const estaExpandido = hijosExpandidos[key];
            const cargando = cargandoHijos[key];
            const modelo = modelosHijos[tablaHija.tablaforanea] || [];

            if (!datosCargados && !cargando) return null;

            const camposVisibles = modelo.filter(campo =>
                campo.nombre_campo !== 'id' &&
                campo.mostrar_consulta === 'Si'
            );

            // Obtener el id_menu del primer campo para las acciones
            const idMenu = camposVisibles.length > 0 ? camposVisibles[0]?.id_menu : 201;

            return (
                <div key={key} className="card mb-3">
                    <div
                        className="card-header bg-secondary d-flex justify-content-between align-items-center"
                        style={{ cursor: 'pointer' }}
                        onClick={() => {
                            this.setState(prevState => ({
                                hijosExpandidos: {
                                    ...prevState.hijosExpandidos,
                                    [key]: !prevState.hijosExpandidos[key]
                                }
                            }));
                        }}
                    >
                        <h6 className="mb-0">
                            <FontAwesomeIcon icon={estaExpandido ? faEyeSlash : faEye} className="me-2" />
                            <span className="badge bg-info p-2">
                                {tablaHija.tablaforanea || 'Tabla relacionada'}
                            </span>
                            {datosCargados && datosCargados.datos && (
                                <span className="badge bg-secondary ms-2">
                                    {datosCargados.datos.length} registros
                                </span>
                            )}
                        </h6>
                        <div onClick={(e) => e.stopPropagation()}>
                            {/* Botón para exportar a Excel */}
                            {datosCargados && datosCargados.datos && datosCargados.datos.length > 0 && (
                                <button
                                    type="button"
                                    className="btn btn-outline-light btn-xs me-2"
                                    onClick={() => this.exportarTablaHijaExcel(tablaHija.tablaforanea, datosCargados.datos, camposVisibles)}
                                    title="Exportar a Excel"
                                >
                                    <FontAwesomeIcon icon={faFileExcel} /> Exportar Excel
                                </button>
                            )}

                            {/* Botón para agregar nuevo registro en esta tabla hija - deshabilitado si estado_inventario != 1 */}
                            <button
                                type="button"
                                className="btn btn-success btn-xs me-2"
                                onClick={() => {
                                    this.abrirFormularioNuevo(
                                        tablaHija.tablaforanea,
                                        tablaHija.relacion_fk,
                                        ide,
                                        idMenu
                                    );
                                }}
                                title={!botonesHabilitados ? "No disponible - Inventario inactivo" : "Agregar nuevo registro"}
                                disabled={!botonesHabilitados}
                            >
                                <FontAwesomeIcon icon={faPlus} /> Nuevo
                            </button>
                            {cargando && (
                                <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                            )}
                        </div>
                    </div>

                    {estaExpandido && datosCargados && datosCargados.datos && datosCargados.datos.length > 0 && (
                        <div className="card-body">
                            <div className="table-responsive">
                                <table className="table table-sm table-bordered table-striped text-nowrap" style={{ fontSize: "11px" }}>
                                    <thead className="table-success">
                                        <tr>
                                            <th style={{ width: "45px", textAlign: "center" }}>#</th>
                                            <th>Acciones</th>
                                            {camposVisibles.map(campo => (
                                                <th key={campo.id} className="small">
                                                    {campo.nombre_titulo}
                                                </th>
                                            ))}
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {datosCargados.datos.map((registro, idx) => (
                                            <tr key={registro.id || idx}>
                                                <td className="text-center fw-bold">{idx + 1}</td>
                                                <td>
                                                    <div className="btn-group" role="group">
                                                        {/* Botón para editar registro - deshabilitado si estado_inventario != 1 */}
                                                        <button
                                                            type="button"
                                                            className="btn btn-primary btn-xs"
                                                            onClick={() => this.abrirFormularioEditar(
                                                                idMenu,
                                                                registro.id,
                                                                tablaHija.tablaforanea,
                                                                tablaHija.relacion_fk,
                                                                ide
                                                            )}
                                                            title={!botonesHabilitados ? "No disponible - Inventario inactivo" : "Editar"}
                                                            disabled={!botonesHabilitados}
                                                        >
                                                            <FontAwesomeIcon icon={faEdit} />
                                                        </button>

                                                        {/* Botón para eliminar registro - deshabilitado si estado_inventario != 1 */}
                                                        <button
                                                            type="button"
                                                            className="btn btn-danger btn-xs"
                                                            onClick={() => this.borrarRegistroHijo(
                                                                idMenu,
                                                                registro.id,
                                                                tablaHija.tablaforanea,
                                                                tablaHija.relacion_fk,
                                                                ide
                                                            )}
                                                            title={!botonesHabilitados ? "No disponible - Inventario inactivo" : "Eliminar"}
                                                            disabled={!botonesHabilitados}
                                                        >
                                                            <FontAwesomeIcon icon={faTrashAlt} />
                                                        </button>
                                                    </div>
                                                </td>
                                                {camposVisibles.map(campo => (
                                                    <td key={campo.id} className="small">
                                                        {this.renderCampoValor(registro, campo)}
                                                    </td>
                                                ))}
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    )}

                    {estaExpandido && datosCargados && (!datosCargados.datos || datosCargados.datos.length === 0) && (
                        <div className="card-body">
                            <div className="alert alert-warning mb-0">
                                No hay registros en {tablaHija.tablaforanea}
                            </div>
                        </div>
                    )}
                </div>
            );
        });
    }

    render() {
        const { load, Titulo, ModeloPrincipal, btnGuadar, isLoadingOpen, TablaModal, searchTerm, showFormModal, ModeloFormularioDetalle, btnGuadarDetalle, esBusquedaDetalle, estadoInventario, DataPrincipal } = this.state;
        const botonesHabilitados = this.botonesHabilitados();

        // Validar si la factura ya fue enviada a Siigo (campo siigo o id_siigo no nulo ni vacío)
        const yaEnviadoSiigo = Boolean(DataPrincipal?.siigo || DataPrincipal?.id_siigo);

        return (
            <div className="content-wrapper">
                <div className="content">
                    <div className="container-fluid">
                        <br />
                        <div className="card">
                            <div className="card-header d-flex justify-content-between align-items-center">
                                <div>
                                    <Link className="btn btn-danger btn-sm" to={`${process.env.PUBLIC_URL}/pages/${this.state.idmenu}/${tema}`}>
                                        <FontAwesomeIcon icon={faTimes} />&nbsp;&nbsp;Cancelar
                                    </Link>
                                    &nbsp;
                                    <button
                                        className="btn btn-primary btn-sm"
                                        onClick={() => this.save()}
                                        disabled={btnGuadar === 1 || !botonesHabilitados}
                                        title={!botonesHabilitados ? "No disponible - Inventario inactivo" : ""}
                                    >
                                        {btnGuadar === 1 ? (
                                            <>
                                                <span className="spinner-border spinner-border-sm me-1" role="status" aria-hidden="true"></span>
                                                Guardando...
                                            </>
                                        ) : (
                                            <>
                                                <FontAwesomeIcon icon={faSave} /> Guardar Cambios
                                            </>
                                        )}
                                    </button>

                                    {/* Botón de imprimir - SIEMPRE HABILITADO con alerta */}
                                    <button
                                        className="btn btn-success btn-sm ms-2"
                                        onClick={this.handleImprimirClick}
                                        title="Imprimir documento"
                                    >
                                        <FontAwesomeIcon icon={faPrint} /> Imprimir Documento
                                    </button>
                                    <button
                                        className="btn btn-warning btn-sm ms-2"
                                        onClick={this.handleImprimirAgrupadoClick}
                                        title="Imprimir documento agrupado"
                                    >
                                        <FontAwesomeIcon icon={faPrint} /> Imprimir Agrupado
                                    </button>
                                    <button
                                        className="btn btn-dark btn-sm ms-2"
                                        onClick={this.handleDescargarRipsJson}
                                        title="Descargar RIPS en formato JSON"
                                    >
                                        <FontAwesomeIcon icon={faDownload} /> Descargar RIPS JSON
                                    </button>

                                    {/* Botón de Enviar a Siigo: habilitado solo si la factura está aprobada (estado_inventario === 2) */}
                                    {!yaEnviadoSiigo && (
                                        <button
                                            className="btn btn-info text-white btn-sm ms-2"
                                            onClick={this.handleEnviarSiigo}
                                            disabled={estadoInventario !== 2}
                                            title={estadoInventario !== 2 ? "Debe aprobar la factura (Estado Aprobado) para habilitar el envío a Siigo" : "Enviar Factura a Siigo"}
                                        >
                                            <FontAwesomeIcon icon={faPaperPlane} /> Enviar a Siigo
                                        </button>
                                    )}

                                    {yaEnviadoSiigo && (
                                        <span className="badge bg-primary p-2 ms-2" title="Factura enviada a Siigo">
                                            <FontAwesomeIcon icon={faPaperPlane} /> Enviado a Siigo ({DataPrincipal?.siigo || DataPrincipal?.id_siigo})
                                        </span>
                                    )}
                                </div>

                                {/* Indicador de estado del inventario */}
                                {estadoInventario !== null && (
                                    <span className={`badge ${estadoInventario === 2 ? 'bg-success' : (estadoInventario === 1 ? 'bg-warning text-dark' : 'bg-secondary')} p-2`}>
                                        {estadoInventario === 2 ? '✅ Aprobado - Listo para Siigo' : (estadoInventario === 1 ? '📝 En Proceso (Activo)' : '⚠️ Inactivo - Modo solo lectura')}
                                    </span>
                                )}
                            </div>

                            <div className="card-header text-center bg-primary text-white">
                                <h4 className="mb-0">Modulo: {Titulo}</h4>
                            </div>

                            <div className="card-body">
                                <div className='row'>
                                    <div className="col-12 border-end">
                                        <h5 className="mb-3 bg-secondary p-2">DATOS PRINCIPALES</h5>
                                        <form id="form_editar">
                                            <input type="hidden" name="id" value={this.state.ide || ''} />
                                            <div className="row">
                                                {ModeloPrincipal.map((row, idx) => (
                                                    row.nombre_campo !== "id" ? (
                                                        <div
                                                            className={`col-md-${row.columna || 12} ${row.alineacion || ''} mb-3`}
                                                            id={`edit_${row.nombre_campo}-div`}
                                                            key={idx}
                                                        >
                                                            {row.tipo_dato === "blob" ? (
                                                                <div className="text-center">
                                                                    <label>{row.orden}.{row.nombre_titulo}</label>
                                                                    <div className="gallery my-gallery">
                                                                        <figure className="col-12">
                                                                            <img
                                                                                className="img-thumbnail"
                                                                                id={"edit_img_" + row.nombre_campo}
                                                                                src="https://static.vecteezy.com/system/resources/previews/022/059/000/non_2x/no-image-available-icon-vector.jpg"
                                                                                alt={row.nombre_titulo}
                                                                                style={{ maxHeight: '150px', maxWidth: '100%' }}
                                                                            />
                                                                        </figure>
                                                                    </div>
                                                                </div>
                                                            ) : (
                                                                <label htmlFor={`edit_${row.nombre_titulo}`}>
                                                                    {row.orden}.{row.nombre_titulo}{" "}
                                                                    {row.obligatorio === "1" ? <span className="text-danger">*</span> : ""}
                                                                </label>
                                                            )}

                                                            {row.trae_tabla === null ? (
                                                                row.tipo_dato === "text" ? (
                                                                    <textarea
                                                                        className="form-control form-control-sm"
                                                                        readOnly={row.campo_editable !== "Si" || !botonesHabilitados}
                                                                        name={row.nombre_campo}
                                                                        id={"edit_" + row.nombre_campo}
                                                                        rows="3"
                                                                    ></textarea>
                                                                ) : row.tipo_dato === "blob" ? null : (
                                                                    <input
                                                                        className="form-control form-control-sm"
                                                                        readOnly={row.campo_editable !== "Si" || !botonesHabilitados}
                                                                        type={
                                                                            row.tipo_dato === "int" ? "number" :
                                                                                row.tipo_dato === "date" ? "date" :
                                                                                    row.tipo_dato === "time" ? "time" :
                                                                                        row.tipo_dato === "datetime" ? "datetime-local" :
                                                                                            "text"
                                                                        }
                                                                        name={row.nombre_campo}
                                                                        id={"edit_" + row.nombre_campo}
                                                                    />
                                                                )
                                                            ) : (
                                                                <>
                                                                    <input
                                                                        type="hidden"
                                                                        name={row.nombre_campo}
                                                                        id={"edit_" + row.nombre_campo}
                                                                    />
                                                                    <div className="input-group mb-3">
                                                                        <input
                                                                            className="form-control form-control-sm"
                                                                            readOnly
                                                                            type="text"
                                                                            name={row.nombre_campo + "_name"}
                                                                            id={"edit_" + row.nombre_campo + "_name"}
                                                                        />
                                                                        <button
                                                                            className="btn btn-outline-secondary btn-sm"
                                                                            onClick={() =>
                                                                                this.Buscar(
                                                                                    row.trae_tabla,
                                                                                    row.trae_value,
                                                                                    row.trae_campo,
                                                                                    row.nombre_campo,
                                                                                    row.trae_opcional
                                                                                )
                                                                            }
                                                                            type="button"
                                                                            data-bs-toggle="modal"
                                                                            data-bs-target="#ModalSelectEdit"
                                                                            disabled={row.campo_editable !== "Si" || !botonesHabilitados}
                                                                            title={!botonesHabilitados ? "No disponible - Inventario inactivo" : ""}
                                                                        >
                                                                            <FontAwesomeIcon icon={faSearch} />
                                                                        </button>
                                                                    </div>
                                                                </>
                                                            )}
                                                        </div>
                                                    ) : null
                                                ))}
                                            </div>
                                        </form>
                                    </div>
                                    <div className="col-12">
                                        <h5 className="mb-3 bg-secondary p-2">DATOS RELACIONADOS</h5>
                                        {this.renderTablasHijas()}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Modal de selección */}
                <div
                    className="modal fade"
                    id="ModalSelectEdit"
                    tabIndex={-1}
                    aria-labelledby="ModalSelectEditLabel"
                    aria-hidden="true"
                    style={{ zIndex: 99999 }}
                >
                    <div className="modal-dialog modal-dialog-centered modal-dialog-scrollable">
                        <div className="modal-content bg-dark bg-gradient">
                            <div className="modal-header">
                                <h5 className="modal-title" id="ModalSelectEditLabel">
                                    Seleccione un registro
                                </h5>
                                <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close" />
                            </div>
                            <div className="modal-body">
                                <div>
                                    <div className="tab-content" id="pills-tabContent">
                                        <div className="tab-pane fade show active" id="pills-home" role="tabpanel">
                                            <div className="card">
                                                <div className="card-body">
                                                    <div className="row g-3" id="f1">
                                                        <input
                                                            type="text"
                                                            placeholder="Buscar por ID, nombre o descripción..."
                                                            className="form-control mb-3"
                                                            value={searchTerm}
                                                            onChange={this.handleSearch}
                                                            autoFocus
                                                        />

                                                        {TablaModal && TablaModal.length > 0 && (
                                                            <div className="mb-2 text-muted small">
                                                                {TablaModal.length} registro(s) encontrado(s)
                                                            </div>
                                                        )}

                                                        <div className="table-responsive" style={{ maxHeight: '400px' }}>
                                                            <table className="table table-hover table-condensed table-sm">
                                                                <thead className="thead-inverse">
                                                                    <tr>
                                                                        <th className="align-middle">ID</th>
                                                                        <th className="align-middle">DESCRIPCIÓN</th>
                                                                    </tr>
                                                                </thead>
                                                                <tbody>
                                                                    {isLoadingOpen ? (
                                                                        <tr>
                                                                            <td colSpan="2" className="text-center">
                                                                                <div className="text-center p-3">
                                                                                    <div className="spinner-border text-primary" role="status">
                                                                                        <span className="sr-only">Cargando...</span>
                                                                                    </div>
                                                                                    <p className="mt-2">Cargando datos...</p>
                                                                                </div>
                                                                            </td>
                                                                        </tr>
                                                                    ) : TablaModal && TablaModal.length > 0 ? (
                                                                        TablaModal.map((item) => (
                                                                            <tr key={item.id} style={{ cursor: 'pointer' }}>
                                                                                <td>{item.id}</td>
                                                                                <td>
                                                                                    <a
                                                                                        onClick={() => {
                                                                                            if (esBusquedaDetalle) {
                                                                                                this.SeleccionarDetalle(item.id, item.nombre, item.tabla);
                                                                                            } else {
                                                                                                this.Seleccionar(item.id, item.nombre, item.tabla);
                                                                                            }
                                                                                        }}
                                                                                        data-bs-dismiss="modal"
                                                                                        style={{ cursor: 'pointer', color: '#007bff', textDecoration: 'none' }}
                                                                                    >
                                                                                        <ins>{item.nombre || item.descripcion || 'Sin nombre'}</ins>
                                                                                    </a>
                                                                                </td>
                                                                            </tr>
                                                                        ))
                                                                    ) : (
                                                                        <tr>
                                                                            <td colSpan="2" className="text-center text-muted">
                                                                                No hay datos disponibles
                                                                            </td>
                                                                        </tr>
                                                                    )}
                                                                </tbody>
                                                            </table>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="modal-footer">
                                <button type="button" className="btn btn-secondary" data-bs-dismiss="modal">
                                    Cerrar
                                </button>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Modal de formulario para tablas hijas */}
                {showFormModal && (
                    <div
                        className="modal fade show"
                        id="FormularioModalDetalle"
                        data-bs-backdrop="static"
                        data-bs-keyboard="false"
                        aria-labelledby="FormularioModalDetalleLabel"
                        aria-hidden="true"
                        style={{ display: 'block', backgroundColor: 'rgba(0,0,0,0.5)' }}
                    >
                        <div className="modal-dialog modal-xl" role="document">
                            <div className="modal-content">
                                <div className="modal-header">
                                    <h4 className="modal-title" id="FormularioModalDetalleLabel">
                                        {this.state.idRegistroDetalle ? 'Editar Registro' : 'Nuevo Registro'} - {this.state.TablaRelacionActual}
                                    </h4>
                                    <button type="button" className="btn-close" onClick={this.cerrarModalDetalle} aria-label="Close"></button>
                                </div>
                                <div className="modal-body">
                                    <form id="form_registro_detalle">
                                        <div className="card-body">
                                            <div className="row">
                                                <div className="card">
                                                    <div className="row card-body">
                                                        <input type="hidden" id="detalle_sub_id" name="id" value={this.state.idRegistroDetalle || ''} />

                                                        {ModeloFormularioDetalle.map((row, idx) => (
                                                            row.nombre_campo !== "id" ? (
                                                                <div
                                                                    className={`col-md-${row.columna} ${row.alineacion}`}
                                                                    id={`detalle_${row.nombre_campo}-div`}
                                                                    key={idx}
                                                                >
                                                                    {row.tipo_dato === "blob" ? (
                                                                        <div className="gallery my-gallery card-body row">
                                                                            <figure className="col-xl-12 col-md-12 col-12">
                                                                                <a href="#" data-size="1600x950">
                                                                                    <img
                                                                                        className="img-thumbnail"
                                                                                        id={"detalle_img_" + row.nombre_campo}
                                                                                        src="https://static.vecteezy.com/system/resources/previews/022/059/000/non_2x/no-image-available-icon-vector.jpg"
                                                                                        alt={row.nombre_titulo}
                                                                                        style={{ maxHeight: '150px' }}
                                                                                    />
                                                                                </a>
                                                                                <figcaption>
                                                                                    {row.orden}.{row.nombre_titulo}
                                                                                </figcaption>
                                                                            </figure>
                                                                        </div>
                                                                    ) : (
                                                                        <label htmlFor={`detalle_${row.nombre_titulo}`}>
                                                                            {row.orden}.{row.nombre_titulo}{" "}
                                                                            {row.obligatorio === "1" ? <span className="text-danger">*</span> : ""}
                                                                        </label>
                                                                    )}

                                                                    {row.trae_tabla === null ? (
                                                                        row.tipo_dato === "text" ? (
                                                                            <textarea
                                                                                className="form-control form-control-sm"
                                                                                readOnly={row.campo_editable !== "Si" || !botonesHabilitados}
                                                                                name={row.nombre_campo}
                                                                                id={"detalle_" + row.nombre_campo}
                                                                                rows="3"
                                                                            ></textarea>
                                                                        ) : row.tipo_dato === "blob" ? null : (
                                                                            <><input
                                                                                className="form-control form-control-sm"
                                                                                readOnly={row.campo_editable !== "Si" || !botonesHabilitados}
                                                                                type={
                                                                                    row.tipo_dato === "int" ? "number" :
                                                                                        row.tipo_dato === "date" ? "date" :
                                                                                            row.tipo_dato === "time" ? "time" :
                                                                                                row.tipo_dato === "datetime" ? "datetime-local" :
                                                                                                    "text"
                                                                                }
                                                                                name={row.nombre_campo}
                                                                                id={"detalle_" + row.nombre_campo}
                                                                                defaultValue={this.state.idRegistroDetalle ? this.state.DataPrincipal?.[row.nombre_campo] : ''}
                                                                                onBlur={(e) => {
                                                                                    if (String(this.state.idmenuDetalle) === "214" || this.state.TablaRelacionActual === "factura_detalle") {
                                                                                        if (["cantidad", "precio", "copago"].includes(row.nombre_campo)) {
                                                                                            const cant = parseFloat(document.getElementById("detalle_cantidad")?.value || 0);
                                                                                            const prec = parseFloat(document.getElementById("detalle_precio")?.value || 0);
                                                                                            const cop = parseFloat(document.getElementById("detalle_copago")?.value || 0);
                                                                                            const totalInput = document.getElementById("detalle_total_detalle");
                                                                                            if(totalInput) totalInput.value = (cant * prec) - cop;
                                                                                        }
                                                                                    }
                                                                                    if (row.control_funcion != null) {
                                                                                        this.FuncionGenerica(row.nombre_campo, row.control_funcion);
                                                                                    }
                                                                                }}
                                                                                disabled={!botonesHabilitados}
                                                                            />
                                                                            </>
                                                                        )
                                                                    ) : (
                                                                        <>
                                                                            <input
                                                                                type="hidden"
                                                                                name={row.nombre_campo}
                                                                                id={"detalle_" + row.nombre_campo}
                                                                            />
                                                                            <div className="input-group mb-3">
                                                                                <input
                                                                                    className="form-control form-control-sm"
                                                                                    readOnly
                                                                                    type="text"
                                                                                    name={row.nombre_campo + "_name"}
                                                                                    id={"detalle_" + row.nombre_campo + "_name"}
                                                                                />
                                                                                <button
                                                                                    className="btn btn-outline-secondary btn-sm"
                                                                                    onClick={() =>
                                                                                        this.BuscarDetalle(
                                                                                            row.trae_tabla,
                                                                                            row.trae_value,
                                                                                            row.trae_campo,
                                                                                            row.nombre_campo,
                                                                                            row.trae_opcional
                                                                                        )
                                                                                    }
                                                                                    type="button"
                                                                                    data-bs-toggle="modal"
                                                                                    data-bs-target="#ModalSelectEdit"
                                                                                    disabled={row.campo_editable !== "Si" || !botonesHabilitados}
                                                                                    title={!botonesHabilitados ? "No disponible - Inventario inactivo" : ""}
                                                                                >
                                                                                    <FontAwesomeIcon icon={faSearch} />
                                                                                </button>
                                                                            </div>
                                                                        </>
                                                                    )}
                                                                </div>
                                                            ) : null
                                                        ))}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <div className="modal-footer">
                                            <button
                                                type="button"
                                                className="btn btn-primary btn-sm"
                                                disabled={btnGuadarDetalle === 1 || !botonesHabilitados}
                                                onClick={this.saveDetalle}
                                                title={!botonesHabilitados ? "No disponible - Inventario inactivo" : ""}
                                            >
                                                {btnGuadarDetalle === 1 ? (
                                                    <>
                                                        <span className="spinner-border spinner-border-sm me-1" role="status" aria-hidden="true"></span>
                                                        Guardando...
                                                    </>
                                                ) : (
                                                    "Guardar Registro"
                                                )}
                                            </button>
                                            <button type="button" className="btn btn-danger btn-sm" onClick={this.cerrarModalDetalle}>
                                                Cerrar
                                            </button>
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                )}
            </div>
        );
    }
}

export default Editar;